<!-- <div class="message-type"></div> -->
<h1 mat-dialog-title>
    <!-- Mostrar icono verde de éxito cuando type sea 'success' explícitamente -->
    <img *ngIf="!data.loading && data.type === 'success'" src="success.gif" width="60" height="60">
    <!-- Mostrar warning sólo cuando type sea 'warning' -->
    <img *ngIf="!data.loading && data.type === 'warning'" src="warning.gif" width="60" height="60">
    <!-- Fallback: si viene 'info' u otro valor, usa info.gif si existe; de lo contrario, success por defecto -->
    <img *ngIf="!data.loading && data.type !== 'success' && data.type !== 'warning'" src="info.gif" width="60" height="60">
    <p>{{ data.title }}</p>
</h1>
<mat-dialog-content>
    <div class="center"> <img *ngIf="data.loading" src="loader.gif"> </div>
    <!-- <mat-progress-bar mode="determinate" value="40"></mat-progress-bar> -->
    <!-- <mat-progress-bar mode="indeterminate"></mat-progress-bar> -->
    <div class="center"><p [innerHTML]="data.message"></p></div>
</mat-dialog-content>
<mat-divider *ngIf="data.dismissBtn||data.acceptBtn"></mat-divider>
<mat-dialog-actions *ngIf="data.dismissBtn||data.acceptBtn" align="end">
    <button *ngIf="data.dismissBtn" mat-raised-button (click)="close(false)"> {{ data.dismissBtnText ? data.dismissBtnText : 'Cancelar' }}</button>
    <button *ngIf="data.acceptBtn" color="primary" mat-raised-button (click)="close(true)">{{ data.acceptBtnText ? data.acceptBtnText : 'Aceptar' }}</button>
</mat-dialog-actions>
